import axios from "axios";
import {openProductAddToCartPopup} from "./productAddToCartPopup";
import {openMicrocart} from "./microcart";

const addToCartForm = document.querySelector('.js-product-add-to-cart-form');

if(addToCartForm) {
    addToCartForm.addEventListener('submit', async e => {
        e.preventDefault();

        const trigger = document.querySelector('.js-product-add-to-cart-submit');
        const microcartCount = document.querySelector('.js-microcart-count');
        const productVariant = document.querySelector('.js-product-variant');
        const productExtras = [...document.querySelectorAll('.js-product-extra')];

        const formData = {items: [{id: productVariant.value, quantity: 1}]};
        productExtras.filter(extra => extra.checked).map(extra => formData.items.push({id: extra.value, quantity: 1}));

        trigger.setAttribute('data-state', 'loading');

        try {
            let response = await axios.post(`${addToCartForm.action}.js`, JSON.stringify(formData), {headers: {'Content-Type': 'application/json'}});

            if(response.status === 200) {
                let cartResponse = await axios.get(`${window.Shopify.routes.root}cart.js`);

                if(cartResponse.status === 200) {
                    microcartCount.setAttribute('data-count', cartResponse.data.items.length);

                    trigger.setAttribute('data-state', 'done');

                    if(!openProductAddToCartPopup(cartResponse.data)) {
                        await openMicrocart(cartResponse.data);
                    }
                }
            }
        } catch (e) {
            // TODO: Handle stock errors
        }
    });
}
